var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Type } from './Type';
var FixedInt = /** @class */ (function (_super) {
    __extends(FixedInt, _super);
    function FixedInt(size) {
        var _this = _super.call(this) || this;
        _this._size = size;
        _this._maxValue = Math.pow(64, _this._size) - 1;
        return _this;
    }
    FixedInt.prototype.encodeBuffer = function (value, buffer) {
        if (value < 0 || value > this._maxValue) {
            throw new RangeError('value must be between 0 and ' + this._maxValue);
        }
        for (var mult = Math.pow(64, this._size - 1); mult >= 1; mult /= 64) {
            buffer.write(Math.floor(value / mult) % 64);
        }
    };
    FixedInt.prototype.decodeBuffer = function (buffer) {
        var value = 0;
        for (var mult = Math.pow(64, this._size - 1); mult >= 1; mult /= 64) {
            value += buffer.read() * mult;
        }
        return value;
    };
    return FixedInt;
}(Type));
export { FixedInt };
